import Client from './HTTPClient';

const API = {
  list (request) {
    return Client.get('/api/personaTargetAudience/', request);
  }
};

export default API;
